import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type Firmware } from '@devices/models/firmware';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FirmwareService {
  private http = inject(HttpClient);

  getList(params?: { filters?: object; limit?: number; offset?: number; }) {
    return this.http.post<{ data: Firmware[] }>(
      'devices/v1/firmware/search',
       params ,
    ).pipe(map(response => response.data));
  }

  upload(formData: FormData) {
    return this.http.post<Firmware>('devices/v1/firmware', formData);
  }

  delete(id: string) {
    return this.http.delete(`devices/v1/firmware/${id}`);
  }

  updateDevice(firmwareId: string, deviceId: string) {
    return this.http.post<Firmware>(`devices/v1/firmware/${firmwareId}/send`, { device: deviceId });
  }
}
